import * as Sentry from '@sentry/nuxt'

const dsn = import.meta.env.VITE_SENTRY_DSN
const enabled = import.meta.env.VITE_SENTRY_ENABLED === 'true'

if (dsn && enabled) {
  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_ENVIRONMENT_NAME || 'development',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 0.5,
    integrations: [Sentry.replayIntegration()],
  })
}
